import React from 'react';
import { motion } from 'framer-motion';

const expertise = [
  {
    title: "Data Science & Analysis",
    icon: "💻",
    tools: ["Python", "pandas", "numpy", "scikit-learn", "matplotlib", "seaborn"],
    color: "from-blue-500 to-cyan-400"
  },
  {
    title: "Data Visualization & SQL",
    icon: "📊",
    tools: ["SQL", "Excel", "Power BI"],
    color: "from-green-500 to-emerald-400"
  },
  {
    title: "Statistical Research",
    icon: "🔬",
    tools: ["SPSS", "Smart PLS"],
    color: "from-purple-500 to-indigo-400"
  },
  {
    title: "Documentation & Presentation",
    icon: "📝",
    tools: ["MS Word", "PowerPoint"],
    color: "from-orange-500 to-yellow-400"
  }
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 100 }
  }
};

export default function ExpertiseSection() {
  return (
    <section className="py-16 px-4 bg-white">
      <motion.div 
        className="max-w-6xl mx-auto"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <h2 className="text-3xl font-cinzel font-bold text-center mb-12 text-gray-800 tracking-widest">
          Tools & Software Expertise
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {expertise.map((item, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ scale: 1.03, y: -5 }}
              className="bg-gray-50 p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${item.color} flex items-center justify-center text-2xl mb-4 shadow-sm`}>
                {item.icon}
              </div>
              
              <h3 className="text-lg font-bold text-gray-800 mb-3">{item.title}</h3>
              
              <div className="flex flex-wrap gap-2">
                {item.tools.map((tool, i) => (
                  <span 
                    key={i}
                    className="text-xs font-medium px-2 py-1 bg-white border border-gray-200 text-gray-600 rounded-md"
                  >
                    {tool}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}